<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import '@/assets/css/icon_fonts.css';
	import '@/assets/css/common.css';
	import {
		sysSelect
	} from '@/utils/systemSelect.js';

	export default {
		name: 'app',
		created: function() {
			this.fun_go_where();
		},
		methods: {
			fun_go_where: function() {
				var now_sys = '';
				now_sys = sysSelect();
				console.log('去哪里.............' + now_sys);
				if (now_sys == 'YD') {
					// window.open('http://yd.sxrhkj.cn/');
					location.assign('http://yd.shanxilingke.cn/');
					
					// console.log('我要去移动界面');
				}

				// 加一次2秒后判断
			}
		},
		beforeDestroy: function() {
			//Vue 实例销毁之前调用。在这一步，实例仍然完全可用。
			localStorage.setItem('userdata', '');
			localStorage.setItem('userno', '');
			localStorage.setItem('pwd', '');
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		
	}
</style>
